import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NguiMapModule } from '@ngui/map';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AccordionModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { AgmModule } from '../shared/models/agm.module';
import { TranslationModule } from '../shared/models/translation.module';
import { SharedModule } from '../shared/shared.module';
import { CreateLoadhseetDeliveryComponent } from './create-loadhseet-delivery.component';
import { MapsContentComponent } from './maps-modal/maps-content.component';
import { MapsModalComponent } from './maps-modal/modal-container/maps-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    AccordionModule.forRoot(),
    AgmModule,

    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NguiMapModule.forRoot({ apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyDpzFm0JwSmVUbSHVJxsngbxRcm9vreGcI' }),


    TranslationModule,
    SharedModule
  ],
  declarations: [
    CreateLoadhseetDeliveryComponent,
    MapsModalComponent,
    MapsContentComponent,
  ],
  providers: [
    NgbActiveModal
  ],
  entryComponents: [
    MapsModalComponent
  ]
})
export class LoadsheetModule {

}